import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const SequenceMovementList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingMovementLink', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation) 
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    const typeColumn = (rowData) => {
        const typeMap = {
            0: t('Next'),
            1: t('Demurrage'),
            2: t('Handling Out'),
            3: t('Handling In'),
            4: t('Other'),
            5: t('Terminal'),
            6: t('Load Date'),
            7: t('Gate Date'),
            8: t('Book'),
            9: t('Container'),
            10: t('Seal'),
            11: t('New Cycle'),
            12: t('Gate In'),
            13: t('Gate Out'),
            14: t('Terminal')
        }
        return typeMap[rowData.Type] || rowData.Type || ''
    }

    const outBoundColumn = (rowData) => {
        const boundMap = {
            0: t('Export'),
            1: t('Import'),
            2: t('Transit'),
            3: t('Internal'),
            4: t('Operations'),
            5: t('Other')
        }
        return boundMap[rowData.MovementTypeOutBound] || rowData.MovementTypeOutBound || ''
    }

    const inBoundColumn = (rowData) => {
        const boundMap = {
            0: t('Export'),
            1: t('Import'),
            2: t('Transit'),
            3: t('Internal'),
            4: t('Operations'),
            5: t('Other')
        }
        return boundMap[rowData.MovementTypeInBound] || rowData.MovementTypeInBound || ''
    }

    const outLocationColumn = (rowData) => {
        const locationMap = {
            0: t('None'),
            1: t('From'),
            2: t('To'),
            3: t('Final')
        }
        return locationMap[rowData.OutLocationField] || rowData.OutLocationField || ''
    }

    const inLocationColumn = (rowData) => {
        const locationMap = {
            0: t('None'),
            1: t('From'),
            2: t('To'),
            3: t('Final')
        }
        return locationMap[rowData.InLocationField] || rowData.InLocationField || ''
    }

    return (
        <M_Table
            entityName={'MovementLink'}
            api='secondary'
            showTitle={true}
            title={'Sequence Movements'} 
            roleName={'usersGroups'}
            rolePermissions={roles}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/sequenceMovementCrud', 'Create', t('Add')+' '+t('Sequence Mov.'), row)],
                ['Edit', (row) => newRoute('containerControl/sequenceMovementCrud', 'Edit', t('Edit')+' '+t('Sequence Mov.'), row)],
                ['Copy', (row) => newRoute('containerControl/sequenceMovementCrud', 'Copy', t('Copy')+' '+t('Sequence Mov.'), row)],
            ])}
            columnTemplates={[
                {
                    field: 'Type',
                    body: typeColumn
                },
                {
                    field: 'MovementTypeOutBound',
                    body: outBoundColumn
                },
                {
                    field: 'MovementTypeInBound',
                    body: inBoundColumn
                },
                {
                    field: 'OutLocationField',
                    body: outLocationColumn
                },
                {
                    field: 'InLocationField',
                    body: inLocationColumn
                }
            ]}
        />
    )
}